import React, { FC } from "react"
import styled from "styled-components"
import { HelperIcon, InterfaceIcon, TimeIcon } from "./icons"

const SBenefits = styled.div`
  display: flex;
  max-width: 1220px;
  margin: 0 auto;
  
  padding: 0 18px;
  margin-bottom: 64px;

  @media screen and (max-width: 1023px) {
    padding: 0 69px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const SBenefit = styled.div`
  width: 100%;

  &:not(:last-child):not(:first-child) {
    margin: 0 12px;
  }
`

const SContent = styled.p`
  max-width: 270px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #333f48;

  @media screen and (max-width: 1023px) {
    max-width: 190px;
  }
`

const SIcon = styled.div`
  margin-bottom: 14px;
`

const SHeading = styled.h4`
  @media screen and (max-width: 768px) {
    margin-top: 12px;
  }
`

const content = [
  {
    icon: <InterfaceIcon />,
    title: 'Онлайн',
    content: 'Вся информация о ваших договорах КПП доступна 24/7/365.',
  },
  {
    icon: <TimeIcon />,
    title: 'Отчеты',
    content: 'Просматривайте отчеты онлайн и получайте их на электронную почту. Удобно. Быстро. Без бумаги!',
  },
  {
    icon: <HelperIcon />  ,
    title: 'Версия №1',
    content: 'Это только начало, следите за обновлениями!',
  },
]

const Benefits: FC = () => {
  return (
    <SBenefits>
      {content.map(benefit => {
        const {icon, title, content} = benefit
        return (
          <SBenefit key={title}>
            <SIcon>{icon}</SIcon>
            <SHeading>{title}</SHeading>
            <SContent>{content}</SContent>
          </SBenefit>
        )
      })}
    </SBenefits>
  )
}

export default Benefits
